module.exports = __webpack_public_path__ + "male-icon-active.8272a44b60be3f2d7d66.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/backup/latestWebCode29march/backup17-june-20/src/assets/images/male-icon-active.svg
// module id = ../../../../../src/assets/images/male-icon-active.svg
// module chunks = main